
import React from 'react';
import PropTypes from 'prop-types';
import { Polygon as PolygonIcon } from '../../../element/icons';


import ToolsBarItemButton from '../../../components/ToolsBar/ToolsBarItemButton';
import { TOOLS_IDS } from '../../../utils/constants';

const PolygonButton = ({ selectTool, isSelected = false, t }) => (
  <ToolsBarItemButton
    className="respark_polygon-tool-button"
    id={TOOLS_IDS.POLYGON}
    label={t('polygonTool')}
    Icon={PolygonIcon}
    onClick={selectTool}
    isSelected={isSelected}
  />
);


PolygonButton.propTypes = {
  selectTool: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default PolygonButton;
